export default __webpack_public_path__ + "static/media/icons_open_menu.034d1ed2.svg";